import React from 'react'
import { PRODUCTIVITY_TYPE } from "../config/settings/constant";
import routes from "../config/settings/routes";
import { usePathParam } from "../modules/hooks/route";
import ProtectBySession from "../components/Security/ProtectBySession";
import BrandLayout from "../components/Layouts/BrandLayout";
import { SummaryKpi } from '@carbon/icons-react'
import { Breadcrumb, BreadcrumbItem } from '@carbon/react'
import Navbar from "../containers/Navbar/Navbar.container";
import ManagementMenu from "../containers/ManagementMenu/ManagementMenu.container";
import Heading from "../components/Layouts/Heading";
import KpiTreeContainer from '../containers/Productivity/KpiTree/KpiTree.container';
import AccessControl from '../components/Security/ProtectByGroup';

/**
 * The Records page.
 */
const Productivity = () => {
    const type = usePathParam('type').toUpperCase();

    const TypeTitle = type => {
        switch (type) {
            case PRODUCTIVITY_TYPE.KPITREE:
                return 'Productividad'
        }
    };

    const getTooltipContent = type => {
        switch (type) {
            case PRODUCTIVITY_TYPE.KPITREE:
                return 'Productividad'    
        }
    };

    const ProductivityBreadcrumbs = () => {
        return (
            <Breadcrumb noTrailingSlash>
                <BreadcrumbItem>
                    <a href="/">Salar</a>
                </BreadcrumbItem>
                {PRODUCTIVITY_TYPE[type] !== PRODUCTIVITY_TYPE['PRODUCTIVITY-INITIAL'] && <BreadcrumbItem isCurrentPage>{TypeTitle(type)}</BreadcrumbItem>}
            </Breadcrumb>
        )
    }

    const typeToComponentMap = {
        [PRODUCTIVITY_TYPE.KPITREE]: KpiTreeContainer
    }
    const ComponentToRender = typeToComponentMap[type];
    console.log(typeToComponentMap[type]);
    

    return (
        <ProtectBySession rule={(hasSession, signedIn) => !!(hasSession && signedIn)}>
            <BrandLayout
                navbar={<Navbar managementMenu={<ManagementMenu current={routes.productivity} />} />}
                header={<Heading title={TypeTitle(type)} icon={<SummaryKpi size={50} />} breadcrumbs={<ProductivityBreadcrumbs />} tooltipContent={getTooltipContent(type)} />}
            >
                <AccessControl type={type}>
                    {ComponentToRender ? <ComponentToRender /> : <div>Component not found</div>}
                </AccessControl>
            </BrandLayout>
        </ProtectBySession>
    )
}

export default Productivity